import { Component, Input } from '@angular/core';
import { ClientTaskHistoryItemActions } from 'app/core/enums/client-task-history-item-actions.enum';
import { ClientTaskHistoryItem } from 'app/core/models/client-task-history-item.model';
import { DatePipe } from '@angular/common';
import { ClientTaskHistoryItemTypeCreatedComponent } from '../client-task-history-item-type-created/client-task-history-item-type-created.component';
import { ClientTaskHistoryItemTypeTransitionedComponent } from '../client-task-history-item-type-transitioned/client-task-history-item-type-transitioned.component';
import { ClientTaskHistoryItemTypeSubmittedComponent } from '../client-task-history-item-type-submitted/client-task-history-item-type-submitted.component';
import { ClientTaskHistoryItemTypeBaseComponent } from '../client-task-history-item-type-base/client-task-history-item-type-base.component';
import { HistoryItemUserNamePipe } from '../../../shared/pipes/history-item-user-name.pipe';

@Component({
    selector: 'app-client-task-history-item-list',
    templateUrl: './client-task-history-item-list.component.html',
    imports: [ClientTaskHistoryItemTypeCreatedComponent,
              ClientTaskHistoryItemTypeTransitionedComponent,
              ClientTaskHistoryItemTypeSubmittedComponent,
              ClientTaskHistoryItemTypeBaseComponent,
              DatePipe,
              HistoryItemUserNamePipe]
})
export class ClientTaskHistoryItemListComponent  {
  @Input() historyItems: ClientTaskHistoryItem[];

  clientTaskHistoryItemActions = ClientTaskHistoryItemActions;
}
